if (!customElements.get("favorites-list")) {
  class FavoritesList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.loadFavoritesList();
    }

    async loadFavoritesList() {
      const favoriteHandles = Favorites.getAll();
      // Array of handles
      const results_wrapper = document.querySelector(".favorites_list");
      const noResults = this.querySelector(".no_results");
      const compareToggle = document.querySelector(".compare_toggle_wrapper");
      const btnsAction = document.querySelector(".btns_action_wrapper");
      const productsListWrapper = document.querySelector(".section_products_list_wrapper");

      // Update favorites count
      updateFavoritesCount();

      if (favoriteHandles.length === 0) {
        noResults.style.display = "flex";
        if (compareToggle) compareToggle.style.display = "none";
        if (btnsAction) btnsAction.style.display = "none";
        if (productsListWrapper) productsListWrapper.style.display = "block";
        const alertBanner = document.querySelector(".alert_banner");
        if (alertBanner) alertBanner.classList.add("alert_banner--hidden");
        if (typeof updateFavoritesLinkState === "function") {
          updateFavoritesLinkState();
        }
        return;
      }

      if (typeof updateFavoritesLinkState === "function") {
        updateFavoritesLinkState();
      }
      noResults.style.display = "none";
      if (compareToggle) compareToggle.style.display = "flex";
      if (btnsAction) btnsAction.style.display = "flex";
      if (productsListWrapper) productsListWrapper.style.display = "none";
      const alertBanner = document.querySelector(".alert_banner");
      if (alertBanner) alertBanner.classList.remove("alert_banner--hidden");

      for (const productHandle of favoriteHandles) {
        try {
          const response = await fetch(`/products/${productHandle}?section_id=favorites-renderer`);
          const html = await response.text();
          // Dom parser the html
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const product = doc.querySelector("favorite-item");

          if (!product) {
            // remove the product from the favorites
            Favorites.remove(productHandle);
            continue;
          }
          results_wrapper.appendChild(product);
        } catch (error) {
          console.error("Error loading product:", productHandle, error);
        }
      }

      // Fetch rendered HTML with metafields
      /* const handlesParam = favoriteHandles.join(",");
      const response = await fetch(`?section_id=favorites-renderer&handles=${handlesParam}`);
      const html = await response.text();

      results_wrapper.innerHTML = html; */
    }
  }
  customElements.define("favorites-list", FavoritesList);
}

if (!customElements.get("favorite-item")) {
  class FavoriteItem extends HTMLElement {
    constructor() {
      super();
      this.removeButton = this.querySelector(".remove-favorite");
    }

    connectedCallback() {
      this.removeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        Favorites.remove(this.removeButton.dataset.productHandle);
        this.remove();

        // Check if there are any favorites left
        const favoriteHandles = Favorites.getAll();

        if (favoriteHandles.length === 0) {
          const noResults = document.querySelector(".no_results");
          const compareToggle = document.querySelector(".compare_toggle_wrapper");
          const btnsAction = document.querySelector(".btns_action_wrapper");
          const alertBanner = document.querySelector(".alert_banner");
          const productsListWrapper = document.querySelector(".section_products_list_wrapper");
          noResults.style.display = "flex";
          if (compareToggle) compareToggle.style.display = "none";
          if (btnsAction) btnsAction.style.display = "none";
          if (alertBanner) alertBanner.classList.add("alert_banner--hidden");
          if (productsListWrapper) productsListWrapper.style.display = "block";
        }

        // Update favorites count
        updateFavoritesCount();

        // Update header favorites link state
        if (typeof updateFavoritesLinkState === "function") {
          updateFavoritesLinkState();
        }
      });
    }
  }
  customElements.define("favorite-item", FavoriteItem);
}

if (!customElements.get("delete-all-favorites")) {
  class DeleteAllFavorites extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        Favorites.removeAll();

        // Show notification
        if (window.showNotification) {
          window.showNotification(`Tous les favoris ont bien été retirés`, { type: "success" });
        }

        // Remove all favorite items from the DOM
        const favoritesList = document.querySelector(".favorites_list");
        if (favoritesList) {
          favoritesList.innerHTML = "";
        }

        const noResults = document.querySelector(".no_results");
        const compareToggle = document.querySelector(".compare_toggle_wrapper");
        const btnsAction = document.querySelector(".btns_action_wrapper");
        const alertBanner = document.querySelector(".alert_banner");
        const productsListWrapper = document.querySelector(".section_products_list_wrapper");
        if (noResults) {
          noResults.style.display = "flex";
        }
        if (compareToggle) compareToggle.style.display = "none";
        if (btnsAction) btnsAction.style.display = "none";
        if (alertBanner) alertBanner.classList.add("alert_banner--hidden");
        if (productsListWrapper) productsListWrapper.style.display = "block";

        // Update favorites count
        updateFavoritesCount();

        // Update header favorites link state
        if (typeof updateFavoritesLinkState === "function") {
          updateFavoritesLinkState();
        }
      });
    }
  }
  customElements.define("delete-all-favorites", DeleteAllFavorites);
}

// Custom element for the fav button
if (!customElements.get("fav-button")) {
  class FavButton extends HTMLElement {
    constructor() {
      super();
      this.attachEventListeners();
    }

    connectedCallback() {}

    attachEventListeners() {
      this.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Get product information
        const productHandle = this.dataset.productHandle;
        const vehicleName = this.dataset.vehicleName || "Ce véhicule";

        // Check if product is already in favorites before toggling
        const wasInFavorites = Favorites.has(productHandle);

        // Toggle favorite in localStorage
        Favorites.toggle(productHandle);

        // Show notification with vehicle name
        if (window.showNotification) {
          if (wasInFavorites) {
            window.showNotification(`Le <strong>${vehicleName}</strong> <br />a bien été retiré des favoris`, { type: "success" });
          } else {
            window.showNotification(`Le <strong>${vehicleName}</strong> <br />a bien été ajouté aux favoris`, { type: "success" });
          }
        }

        // Tracking GTM : add_to_wishlist uniquement lors d'un AJOUT en favori
        if (!wasInFavorites && typeof forgeVehicleItem === "function") {
          try {
            let json = null;
            const card = this.closest(".product_card");
            if (card) json = getCardVehicleJson(card);
            if (!json) {
              const productEl = document.querySelector("script[data-product-json]");
              if (productEl) {
                try {
                  json = JSON.parse(productEl.textContent);
                } catch (parseErr) {}
              }
            }
            if (json) {
              const listWrapper = this.closest("[data-list-name]");
              const listName = listWrapper ? listWrapper.getAttribute("data-list-name") : "";
              pushDataLayer({
                event: "add_to_wishlist",
                currency: "EUR",
                value: json.price,
                ecommerce: { items: [forgeVehicleItem(json, { item_list_name: listName })] },
              });
            }
          } catch (err) {}
        }

        // Update header favorites link state and all fav buttons
        if (typeof updateFavoritesLinkState === "function") {
          updateFavoritesLinkState();
        }
      });
    }
  }
  customElements.define("fav-button", FavButton);
}

// Function to update favorites count
function updateFavoritesCount() {
  const favoritesCount = document.querySelector(".favorites_count");
  if (favoritesCount) {
    const count = Favorites.getCount();
    if (count === 1) {
      favoritesCount.textContent = `${count} van`;
    } else {
      favoritesCount.textContent = `${count} vans`;
    }
  }
}
